var ApiCall = {
  PING: "Ping",
  PING_LEGACY: "ping",
  LOGIN_USER: "LoginUser",
  LOGOUT_USER: "LogoutUser",
  INVOKE_METHOD: "InvokeMethod",
  INVOKE_GET_METHOD: "InvokeGetMethod",
  //#endregion SPECIAL FUNCTIONS

  //#region GET FUNCTIONS
  GET_ACTIVE_TRACKS: "GetActiveTracksDate",
  GET_RACES: "GetRaces",
  GET_ENTRIES: "GetEntries",
  GET_UPCOMING_RACES: "GetUpcomingRaces",
  GET_OFF_RACES: "GetRacesOff",
  GET_RACE: "GetRace",
  GET_RESULTS: "GetResults",
  GET_CHARTS: "GetCharts",
  GET_ACTIVE_BET_TYPES: "GetWagerTypesActivebyChart",
  GET_OPEN_BETS_CHART: "GetOpenBetsbyChart",
  GET_PAST_POSTS: "GetPastPost",
  GET_TRACKS: "GetTracks",
  GET_GAME_PROVIDERS: "GetGameProviders",
  GET_TRACK_CATEGORY: "GetTrackCategory",
  GET_ALT_TRACK_CATEGORY: "GetTrackAltCategory",
  GET_PROFILES: "GetProfiles",
  GET_BOOKS: "GetBooks",
  GET_TRACKS_BY_BOOK: "GetTracksByBook",
  GET_TRACKS_BY_PROFILE: "GetTracksByProfile",
  GET_LIMIT_SET_LIST: "GetLimitSetList",
  GET_LIMIT_SET_ID: "GetLimitSetID",
  GET_LIMIT_SET: "GetLimitSet",
  GET_LAST_CHANGES_LOG: "GetLastChange",
  GET_FIELD_CHANGES_LOG: "GetChangesByField",
  GET_PAST_POST_TICKETS_BY_DATE: "GetPastPostTicketsByDate",
  GET_MANUALLY_SCORE_TICKETS: "GetManualScoreQ",
  GET_SYSTEM_PREFERENCES_RACING: "GetSystemPreferencesRacing",
  GET_OPEN_BETS_WT: "GetOpenBetsbyWT",
  GET_COUNTRIES: "GetCountries",
  GET_STATES: "GetStates",
  GET_ALL_STATES: "GetAllStates",
  GET_MY_IP: "GetMyIP",
  GET_OPEN_BETS_BY_RACE_ID: "GetOpenBetsbyRaceID",
  GET_OPEN_BETS_BY_PERIOD_OFF_TIME: "GetOpenBetsbyPeriodOfTime",
  GET_TRACK_LIST_ENABLED: "GetTrackListEnabled",
  //#endregion GET FUNCTIONS

  //#region INSERT FUNCTIONS
  INSERT_TRACK: "InsertTrack",
  INSERT_TRACK_CATEGORY: "InsertTrackCategory",
  INSERT_TRACK_ALT_CATEGORY: "InsertTrackAltCategory",
  INSERT_TRACKS_BY_BOOK: "InsertTrackByBook",
  COPY_TRACKS_BY_BOOK: "CopyTrackByBook",
  COPY_TRACKS_BY_PROFILE: "CopyProfileTracks",
  INSERT_TRACKS_BY_PROFILE: "InsertProfileTracks",
  INSERT_LIMIT_SET: "InsertLimitSet",
  CLONE_LIMIT_SET: "CloneLimitSet",
  INSERT_DEFAULT_RACE: "savedefaultrace",
  INSERT_LIMIT_SET_BET_TYPE: "InsertLimitSetBetType",
  //#endregion INSERT FUNCTIONS

  //#region UPDATE FUNCTIONS
  UPDATE_RACE: "saverace",
  UPDATE_ENTRIES: "saveentry",
  UPDATE_RESULTS: "saveresults",
  SCORE: "score",
  UNSCORE: "unscore",
  SET_STATUS: "setstatus",
  UPDATE_TRACKS: "UpdateTrack",
  UPDATE_TRACK_CATEGORY: "UpdateTrackCategory",
  UPDATE_TRACK_ALT_CATEGORY: "UpdateTrackAltCategory",
  UPDATE_SYSTEM_PREFERENCES_RACING: "UpdateSystemPreferencesRacing",
  PAY_REBATES: "rebatestickets",
  TICKET_VOID_LIST: "ticketvoidlist",
  SCORE_TICKET_LIST: "scoreticketlist",
  ONLINE_RESET_USER_PASSWORD: "OnlineResetUserPassword",
  VOID: "ticketvoid",
  //#endregion UPDATE FUNCTIONS

  //#region DELETE FUNCTIONS
  DELETE_TRACK: "DeleteTrack",
  DELETE_TRACK_CATEGORY: "DeleteTrackCategory",
  DELETE_TRACK_ALT_CATEGORY: "DeleteTrackAltCategory",
  DELETE_LIMIT_SET: "DeleteLimitSet",
  //#endregion DELETE FUNCTIONS
};

export default ApiCall;
